<style lang="scss" scoped>
@import "$vars";

.col_container {
  padding-bottom: 1em;
  overflow: auto;
}
.col {
  box-sizing: border-box;
  min-width: 240px;
  border-width: 2px;
  border-style: solid;
  border-color: $color-red;
  margin-right: 8px;
  font-size: 0.7rem;
  &.combined {
    border-color: $color-blue;
    >main {
      >span {
        background: $color-blue;
      }
    }
  }
  >header {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      margin: 0
    }
    i {
      font-style: normal;
      margin: 5px 0;
      display: inline-block;
    }
    fieldset {
      padding: 10px;
      label {
        margin-bottom: 10px
      }
      footer {
        margin-top: 10px;
      }
    }

  }
  >main {
    >span {
      background: $color-red;
      color: white;
      display: inline-block;
      width: 100%;
      padding: 5px 10px;
    }
    li {
      border-bottom: 1px solid #e1e1e1;
      padding: 3px 10px
    }
  }
}
.submit {
  float: right;
  margin: 20px 0;
  padding: 0 80px;
}

.colunas-arquivo {
  &__lista {
    box-sizing: border-box;
    max-height: 265px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  &__item {}
}
</style>

<template>
  <main v-if="loaded">
    <p><big>Agora vamos combinar as colunas do seu arquivo com as colunas do sistema Dr.Conecta</big></p>
    <div v-if="ready" class="toast toast-success"><p><strong>Todas as colunas foram combinadas.</strong> Clique no botão <em>Próximo</em> para finalizar</p></div>
    <div class="d-flex col_container">
      <article class="col" :class="imported.isCombined ? 'combined' : ''" v-for="(imported, $index) in importedColumns" :key="'imported'+$index">
        <transition name="fade" mode="out-in">
          <header v-if="!imported.edit" key="1">
            <p class="text-center">
              <strong v-if="imported.isCombined">{{columns[getType][imported.field].label}}</strong>
              <strong v-else>{{imported.title[0]}}</strong><br />
              <i v-if="imported.isCombined">Coluna combinada</i>
              <i v-else class="text-error">Esta coluna não será incluída</i><br />
              <a @click="imported.edit = true">Editar</a>
            </p>
          </header>
          <header key="2" v-else>
            <fieldset>
              <strong>Nome da coluna</strong>
              <label>
                <select v-model="imported.input" class="form-select">
                  <option :value="null">Não incluir</option>
                  <option v-if="imported.field" :value="imported.field">{{columns[getType][imported.field].label}}</option>
                  <option v-for="(field, $index) of columns[getType]" v-show="field.show" :value="$index" :key="'f'+ $index">{{field.label}}</option>
                </select>
              </label>
              <footer>
                <button @click="saveField(imported)" class="btn btn-primary btn-sm" :disabled="sending">Salvar</button>
                <a @click="imported.edit = false">Cancelar</a>
              </footer>
            </fieldset>
          </header>
        </transition>
        <main>
          <span>{{imported.title[0]}}</span>
          <ul class="list-unstyled colunas-arquivo__list">
            <li v-for="(row, $index) of imported.data" :key="'row'+$index" class="colunas-arquivo__item">
              {{row}}
            </li>
          </ul>
        </main>
      </article>
    </div>
    <hr class="col-12" />
    <dr-submit class="submit" @click="submit()" :disabled="!ready" :sending="sending" text="Próximo"></dr-submit>
  </main>
</template>

<script>
import drSubmit from '@/components/form/submit'

export default {
  props: ['selectedOffice', 'fileId'],
  components: {
    drSubmit
  },
  data () {
    return {
      loaded: false,
      sending: false,
      columns: {
        special_patient: [
          {
            name: 'patientImportId',
            label: 'Código do paciente',
            show: true
          },
          {
            name: 'doctorOfficeName',
            label: 'Consultório médico',
            show: true
          },
          {
            name: 'name',
            label: 'Nome',
            show: true
          },
          {
            name: 'email',
            label: 'Email',
            show: true
          },
          {
            name: 'cpf',
            label: 'CPF',
            show: true
          },
          {
            name: 'rg',
            label: 'RG',
            show: true
          },
          {
            name: 'dateOfBirth',
            label: 'Data de nascimento',
            show: true
          },
          {
            name: 'gender',
            label: 'Gênero (Sexo)',
            show: true
          },
          {
            name: 'contactPhone',
            label: 'Telefone de contato',
            show: true
          },
          {
            name: 'nationalHealthCard',
            label: 'Carteira nacional de saúde (Cartão SUS)',
            show: true
          },
          {
            name: 'addressStreet',
            label: 'Endereço - Nome da rua',
            show: true
          },
          {
            name: 'addressNumber',
            label: 'Endereço - Número',
            show: true
          },
          {
            name: 'addressComplement',
            label: 'Endereço - Complemento',
            show: true
          },
          {
            name: 'addressDistrict',
            label: 'Endereço - Bairro',
            show: true
          },
          {
            name: 'addressCep',
            label: 'Endereço - CEP',
            show: true
          },
          {
            name: 'addressCity',
            label: 'Endereço - Cidade',
            show: true
          },
          {
            name: 'addressUf',
            label: 'Endereço - UF',
            show: true
          }
        ],
        agenda: [
          {
            name: 'specialPatient',
            label: 'Código do paciente',
            show: true
          },
          {
            name: 'appointmentStart',
            label: 'Início da consulta (datetime)',
            show: true
          },
          {
            name: 'appointmentFinish',
            label: 'Término da consulta (datetime)',
            show: true
          },
          {
            name: 'type',
            label: 'Tipo',
            show: true
          },
          {
            name: 'value',
            label: 'Valor (R$)',
            show: true
          },
          {
            name: 'status',
            label: 'Status da consulta',
            show: true
          },
          {
            name: 'mainComplaint',
            label: 'Queixa principal',
            show: true
          },
          {
            name: 'diagnosticHypothesis',
            label: 'Hipótese Diagnóstico',
            show: true
          },
          {
            name: 'diagnosticAnalysis',
            label: 'Diagnóstico',
            show: true
          },
          {
            name: 'medicalConsultationStart',
            label: 'Inicio real da consulta',
            show: true
          },
          {
            name: 'medicalConsultationFinish',
            label: 'Término real da consulta',
            show: true
          },
          {
            name: 'importCreatedAt',
            label: 'Data de criação do agendamento',
            show: true
          }
        ],
        financial_statement: [
          {
            name: 'date',
            label: 'Data',
            show: true
          },
          {
            name: 'description',
            label: 'Descrição',
            show: true
          },
          {
            name: 'type',
            label: 'Tipo',
            show: true
          },
          {
            name: 'value',
            label: 'Valor',
            show: true
          },
          {
            name: 'paymentMethod',
            label: 'Forma de pagamento',
            show: true
          },
          {
            name: 'status',
            label: 'Status',
            show: true
          },
          {
            name: 'categoryName',
            label: 'Categoria',
            show: true
          }
        ]
      },
      importedColumns: [],
      ready: false
    }
  },
  computed: {
    getColumns () {
      let cols = this.fn_COPY_ARRAY(this.columns[this.getType])
      for (let row in this.importedColumns) {
        if (this.columns[this.getType][this.importedColumns[row].field]) {
          cols[this.importedColumns[row].field].show = false
        }
      }
      return cols.filter(n => n)
    },
    getType () {
      return this.$route.params.type
    }
  },
  mounted () {
    this.$http.get(`/doctor/doctor_office/${this.selectedOffice.id}/${this.getType}/import/${this.fileId}/data_preview`, this.$store.getters.getAuthHeader).then(
      (res) => {
        let cols = this.fn_COPY_OBJECT(res.data)
        for (let field in cols) {
          cols[field].isCombined = false
          cols[field].edit = false
          cols[field].field = null
          cols[field].input = null
          if (this.isCombined(cols[field].title[0])) {
            cols[field].field = this.isCombined(cols[field].title[0])
            cols[field].input = cols[field].field
            cols[field].isCombined = true
          }
        }
        this.importedColumns = cols
        this.updateSelect()
        this.loaded = true
      }
    )
  },
  methods: {
    isCombined (title) {
      for (let field in this.columns[this.getType]) {
        if (this.fn_REMOVE_ACCENTS(this.columns[this.getType][field].label.toUpperCase().replace('-', '')) === this.fn_REMOVE_ACCENTS(title.toUpperCase().replace('-', ''))) {
          return field
        }
      }
    },
    saveField (column) {
      column.field = column.input
      column.input ? column.isCombined = true : column.isCombined = false
      column.edit = false
      this.updateSelect()
    },
    updateSelect () {
      let ready = false
      let validcount = 0
      for (let col of this.columns[this.getType]) {
        col.show = true
      }
      for (let row in this.importedColumns) {
        if (this.columns[this.getType][this.importedColumns[row].field]) {
          this.columns[this.getType][this.importedColumns[row].field].show = false
          validcount += 1
          if (validcount === this.columns[this.getType].length) {
            ready = true
          }
        }
      }
      this.ready = ready
    },
    submit () {
      let data = {}
      for (let col in this.importedColumns) {
        if (this.importedColumns[col].field) {
          data[this.columns[this.getType][this.importedColumns[col].field].name] = col[0]
        }
      }
      this.sending = true
      let formName = null
      if (this.getType === 'special_patient') {
        formName = 'identify_columns'
      } else if (this.getType === 'agenda') {
        formName = 'agenda_identify_columns'
      } else {
        formName = 'financial_statement_identify_columns'
      }
      let form = {}
      form[formName] = data
      this.$http.post(`/doctor/doctor_office/${this.selectedOffice.id}/${this.$route.params.type}/import/${this.fileId}/identify_columns`, form, this.$store.getters.getAuthHeader).then(
        (res) => {
          this.$router.push(`/doctor/patients/import/${this.$route.params.type}/execute`)
        }
      ).catch(
        (err) => {
          console.log(err)
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: 'Erro no processamento',
            size: 'md',
            active: true
          })
        }
      ).finally(
        () => {
          this.sending = false
          this.fn_HIDE_PROGRESS()
        }
      )
      console.log(data)
    }
  }
}
</script>
